import { render, staticRenderFns } from "./formGroupInput.vue?vue&type=template&id=2aa0f256&"
import script from "./formGroupInput.vue?vue&type=script&lang=js&"
export * from "./formGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa0f256')) {
      api.createRecord('2aa0f256', component.options)
    } else {
      api.reload('2aa0f256', component.options)
    }
    module.hot.accept("./formGroupInput.vue?vue&type=template&id=2aa0f256&", function () {
      api.rerender('2aa0f256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/formGroupInput.vue"
export default component.exports